import { callExternalApi, CallResult } from '../callExternalApi';
import { supplierScoringUrl } from './SupplierScoring';
import { ScoringInvitee, ScoringInviteResult, ScoringReassignResult, ScoringRequestRow } from '../../types/advise';

export const fetchAdviseScoringRequests = async (
  engagementId: string,
  supplierId: string
): Promise<CallResult<{ requests: ScoringRequestRow[] }>> => {
  return callExternalApi<{ requests: ScoringRequestRow[] }>({
    url: `${supplierScoringUrl(engagementId)}/suppliers/${supplierId}/requests`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const postAdviseScoringInvites = async (
  engagementId: string,
  supplierId: string,
  invitees: ScoringInvitee[],
  note: string | null
): Promise<CallResult<ScoringInviteResult>> => {
  return callExternalApi<ScoringInviteResult>({
    url: `${supplierScoringUrl(engagementId)}/suppliers/${supplierId}/invites`,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    data: { invitees, note }
  });
};

export const postAdviseScoringReassign = async (
  engagementId: string,
  requestId: string,
  invitee: ScoringInvitee
): Promise<CallResult<ScoringReassignResult>> => {
  return callExternalApi<ScoringReassignResult>({
    url: `${supplierScoringUrl(engagementId)}/requests/${requestId}/reassign`,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    data: invitee
  });
};
